// CSS
import './FooterNew.css';
// React hooks
import { useNavigate } from 'react-router-dom';
// External hooks/components
import { useMediaQuery } from "react-responsive";       // responsive CSS
// Media assets
import LinkedinIcon from '../../assets/FooterAssets/linkedin-icon-transparent-background.png';
import YoutubeIcon from '../../assets/FooterAssets/youtube-icon.png';
import TwitterIcon from '../../assets/FooterAssets/twitter-icon.png';
import FacebookIcon from '../../assets/FooterAssets/facebook-icon.png';


// =========
// FooterNew - the Footer displayed on landing pages
// =========
function FooterNew() {
    
    // init React hooks
    const navigate = useNavigate('');

    // responsive CSS
    const isDesktop = useMediaQuery({ minWidth: 1025 });

    // =============
    // JSX Component
    // =============
    return(
        <>
            
            {/* === Footer (normal) === */}
            { isDesktop && 
                <div className='FooterNew'>
                    
                    {/* Left Content */}
                    <div className='FooterNew-left'>
                        
                        {/* TOS Button */}
                        <div className='FooterNew-button' onClick={() => navigate('../terms')}>Terms</div>

                        {/* Privacy Policy */}
                        <div className='FooterNew-button' onClick={() => navigate('../privacy')}>Privacy Policy</div>

                    </div>

                    {/* Right Content */}
                    <div className='FooterNew-right'>
                        {/* LinkedIn Button */}
                        <img src={LinkedinIcon} onClick={() => window.open("https://www.linkedin.com/company/skybasedata/?viewAsMember=true", "_blank", "noopener,noreferrer")} className='Footer--linkedin-icon' />
                        
                        {/* YouTube Button */}
                        <img src={YoutubeIcon} className='Footer--youtube-icon' />

                        {/* Twitter (X) Button */}
                        <img src={TwitterIcon} className='Footer--twitter-icon' />

                        {/* Facebook Button */}
                        <img src={FacebookIcon} className='Footer--facebook-icon' />
                    </div>
                </div>
            }

            {/* === Footer (mobile) === */}
            { !isDesktop && 
                <div className='FooterNew-mobile'>

                    {/* Buttons container */}
                    <div className='FooterNew-mobile-buttons-container'>

                        {/* Group left */}
                        <div className='FooterNew-mobile-buttons-container-group-left'>
                            
                            {/* Terms button */}
                            <div className='FooterNew-mobile-buttons-container-button--word' onClick={() => navigate('../terms')}>Terms</div>

                            {/* Privacy button */}
                            <div className='FooterNew-mobile-buttons-container-button--word' onClick={() => navigate('../privacy')}>Privacy</div>
                        
                        </div>

                        {/* Group right */}
                        <div className='FooterNew-mobile-buttons-container-group-right'>
                            
                            {/* LinkedIn button */}
                            <img src={LinkedinIcon} onClick={() => window.open("https://www.linkedin.com/company/skybasedata/?viewAsMember=true", "_blank", "noopener,noreferrer")} className='Footer-mobile-linkedin-icon' />

                            {/* YouTube button */}
                            <img src={YoutubeIcon} onClick={() => window.open("https://www.youtube.com/@skybase-data", "_blank", "noopener,noreferrer")} className='Footer-mobile-youtube-icon' />

                            {/* Twitter button */}
                            <img src={TwitterIcon} onClick={() => window.open("https://x.com/SkybaseData", "_blank", "noopener,noreferrer")} className='Footer-mobile-twitter-icon' />

                            {/* Facebook button */}
                            <img src={FacebookIcon} onClick={() => window.open("https://www.facebook.com/profile.php?id=61591711373065", "_blank", "noopener,noreferrer")} className='Footer-mobile-facebook-icon' />

                        </div>

                    </div>
                </div>
            }
        </>
    )
};


// Export statement
export default FooterNew;